






































































import contactModal from '@/components/Company/Profile/modals/addTeipBizUser.vue';
import companyUser from '@/store/types/companyUser';
import SweetAlert from '@/util/classes/SweetAlert';

import { AxiosError } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import { CompanyUserParams } from '@/store/interfaces/companyUser';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { User } from '@sentry/types';
import { TableRef } from '@/store/interfaces/generic';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const notification = new TeipNotifications();

type userData = {
  company_id: string;
  permission_group_id: string | undefined;
  user: User | undefined;
  user_id?: string | undefined;
};

export default Vue.extend({
  name: 'CompanyUsers',
  components: {
    contactModal,
  },
  data: () => ({
    viewDetails: false,
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: 'Nombre',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'user.email',
        label: 'Email',
        minWidth: 180,
        sortable: true,
      }
    ] as tTableColumns,
    contact_modal: false,
    contactSelected: {},
    rowSelected: {},
    errors: {},
    success: false,
    saveIsSuccess: false,
    deleteContactConfirm: false,
  }),
  computed: {
    ...mapGetters({
      getCompanyUserList: `companyUserModule/${companyUser.getters.GET_COMPANY_USERS}`,
    }),
    companyIdQueryString(): string {
      const companyId = this.$route.params.company_id;
      return `&company_id_eq=${companyId}`;
    },
  },
  methods: {
    ...mapActions({
      CompanyUserList: `companyUserModule/${companyUser.actions.COMPANY_USERS_LIST}`,
      deletedCompanyUser: `companyUserModule/${companyUser.actions.DELETE_COMPANY_USER}`,
      saveUser: `companyUserModule/${companyUser.actions.SAVE_COMPANY_USER}`,
      updateUser: `companyUserModule/${companyUser.actions.UPDATE_COMPANY_USER}`,
    }),
    rowSelect(row: CompanyUserParams): void {
      this.$data.rowSelected = row;
    },
    editUser(): void {
      this.$data.contactSelected = { ...this.$data.rowSelected, };
      this.$data.contact_modal = true;
    },
    newUser(): void {
      this.$data.contactSelected = {};
      this.$data.contact_modal = true;
    },
    triggerContactInfo(val: { update: boolean; user: User }): void {
      if (val.update) {
        this.updateContact(val.user);
      } else {
        this.createContact(val.user);
      }
    },
    updateContact(user: CompanyUserParams): void {
      const data = { ...user, };
      delete data.id;
      delete data.user;
      const dataToSend = {
        user_id: this.$data.contactSelected.id,
        data,
      };
      this.updateUser(dataToSend)
        .then(() => {
          notification.success('Usuario actualizado correctamente');
          this.$data.contact_modal = false;
          (this.$refs.refCompanyUserList as TableRef).debouncedFetch();
        })
        .catch((err: AxiosError) => {
          this.setServerErrors(err);
        })
        .finally(() => {
          this.$data.success = false;
        });
    },
    createContact(user: CompanyUserParams): void {
      const entity_id: string = this.$route.params.company_id;
      const userData: userData = {
        company_id: entity_id,
        permission_group_id: user.permission_group_id,
        user: user.user,
      };
      if (user.id) {
        userData.user_id = user.id;
        delete userData.user;
      }

      this.saveUser(userData)
        .then(() => {
          notification.success('Usuario agregado correctamente');
          this.$data.contact_modal = false;
          this.$data.saveIsSuccess = true;
          (this.$refs.refCompanyUserList as TableRef).debouncedFetch();
        })
        .catch((err: AxiosError) => {
          this.$data.saveIsSuccess = false;
          this.setServerErrors(err);
        });
    },
    setServerErrors(err: AxiosError): void {
      const notificacion = new TeipNotifications();
      if (err.response?.status === 422) {
        this.$data.errors = err.response.data.error;
      } else {
        notificacion.warning('Algo ha salido mal');
      }
    },
    async deleteAction(): Promise<void> {
      const companyUser = this.$data.rowSelected;
      const notification = new TeipNotifications();
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: 'Eliminar Usuario',
          text: '¿Seguro que desea eliminar el Usuario?',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sí, eliminar',
          alertType: 'warning',
        })
        .then((res) => {
          res &&
            this.deletedCompanyUser(companyUser.id)
              .then(() => {
                notification.success('Usuario eliminado');
                (this.$refs.refCompanyUserList as TableRef).debouncedFetch();
              })
              .catch(() => {
                notification.warning('Ha ocurrido un error al eliminar :(');
              });
        });
      (this.$refs.refCompanyUserList as TableRef).fetchData();
    },
  },
});
